import { Box, IconButton, Modal, Typography, TextField } from '@mui/material';
import React, { useState } from 'react';
import './RefundApproveModal.css';
import closeIcon from '../../../../../assets/Admin/RequestImages/close-icon.svg';
import approveIcon from '../../../../../assets/Admin/RequestImages/approve-icon.svg';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '30% !important',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const RefundApproveModal = ({ setApproveOpen, onApprove }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setApproveOpen(false);
  };

  const handleApprove = async () => {
    setIsLoading(true);
    try {
      await onApprove('');
      handleClose();
    } catch (error) {
      console.error('Error in approve modal:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={true}
      aria-labelledby="refund-approve-modal-title"
      aria-describedby="refund-approve-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-[5%] py-4 border-b border-[#D5DEE3]">
          <Typography className="refund-approve-title">Approval Confirmation</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center gap-4 px-6 py-4 border-b border-[#D5DEE3]">
          <img src={approveIcon} alt="approve" width="132.727px" height="70px" />
          <Typography className="refund-approve-text">
            You're about to approve this refund request and return the unused coins. Do you want to
            continue?
          </Typography>
        </Box>
        <Box className="flex items-center justify-center gap-4 px-6 py-4">
          <button className="refund-cancel-button" onClick={handleClose} disabled={isLoading}>
            Cancel
          </button>
          <button className="refund-confirm-button" onClick={handleApprove} disabled={isLoading}>
            {isLoading ? 'Processing...' : 'Confirm'}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RefundApproveModal;
